const user_scopes = {
    descriptions: {
        custom_data: 'Your custom data',
        email: 'Your email address',
        phone: 'Your phone number',
        profile: 'Your name, username, avatar, and other profile info',
        roles: 'Your roles',
        identities: 'Your linked social identities',
        'urn:logto:scope:organizations': 'Your organizations info',
        'urn:logto:scope:organization_roles': 'Your organization roles',
        address: 'Your address',
    },
};
export default Object.freeze(user_scopes);
